import { render, staticRenderFns } from "./physical-volume-documents-dialog.vue?vue&type=template&id=6cb54b9d&lang=pug&"
import script from "./physical-volume-documents-dialog.vue?vue&type=script&lang=ts&"
export * from "./physical-volume-documents-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports